import React, { useEffect } from 'react';
import {Switch } from '@mui/material';

import './Inputs_styles.scss'

const SwitchInput = (props) => {

    const handleChange = (event) => {
        props.setChecked(event.target.checked);
        console.log('handleChange > ', event.target.checked)
    };

    useEffect(()=>{console.log(props.checked, 'props.checked')},[props.checked])

    return(
        <div>
            <Switch
                checked={props.checked? props.checked : false}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
            />
        </div>
    )
}

export default SwitchInput;